import React from "react";

const NetworkOffline = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12 align-self-center text-center">
            <div className="d-flex justify-content-center align-items-center">
              <h2 style={{ color: "#ff9b44" }}>Oops, you&apos;re offline.</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 align-self-center text-center">
            <div className="d-flex justify-content-center align-items-center">
              <p style={{ color: "#ff9b44" }}>
                It looks like your network connection is down. Please check your
                internet and try again.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkOffline;
